var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ee-select-modal"},[_c('div',{staticClass:"ee-select-modal-content"},[_c('model-list',{on:{"change-model":_vm.changeModel}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }